// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void,
  loginFormErrorRelease: () => void
};

type StateType = {};

class LoginError extends Component<PropsType, StateType> {
  render() {
    const { translate, loginFormErrorRelease } = this.props;
    return (
      <div>
        <p className="mb-3 text-center text-danger">
          <i className="fas fa-exclamation-circle fa-4x" />
        </p>
        <p className="mb-3 text-center">{translate("LoginLocale.error.header")}</p>
        <hr className="w-30" />
        <p className="mb-5 text-center">{translate("LoginLocale.error.content")}</p>
        <button
          className="btn btn-block btn-primary btn-label"
          onClick={() => {
            loginFormErrorRelease();
          }}
        >
          <label>
            <i className="fas fa-arrow-left" />
          </label>
          {translate("LoginLocale.error.action")}
        </button>
      </div>
    );
  }
}

export default LoginError;



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/Components/Login/LoginError.js